// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"506":"2902019b","587":"3c2dd36b"}[chunkId] + ".1792742011347.chunk.js";
};